import { defineMessages } from 'react-intl';

export const qrCodeBannerMessages = defineMessages({
    downloadAppCopy: {
        id: 'qrCodeBanner.downloadApp',
        defaultMessage: 'Download the app',
        description:
            'Message prompting the user to download the Calm Health app from the their device app store.',
    },
    scanQrCodeCopy: {
        id: 'qrCodeBanner.scanQrCode',
        defaultMessage: 'Scan the QR code to get Calm Health on the go.',
        description:
            'Message prompting the user to scan the QR code to download the Calm Health app from the their device app store.',
    },
});
